
import { defineComponent } from 'vue'
import CmSvgIcon from './cm-svg-icon.vue'

export default defineComponent({
  name: 'BlueTipsIcon',
  components: { CmSvgIcon },
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
  },
})
